// app/javascript/controllers/concerns/sortable_handler.js

export function handleSortableUpdate(event, options = {}) {
  const item = event.item
  const form = item.querySelector('form')
  const formData = new FormData()

  // 担当者IDの設定（assignment用）
  if (event.to.dataset.spaceUserId !== undefined) {
    formData.append('assignee_id', event.to.dataset.spaceUserId || '')
  }

  // 進捗状態の設定（progress用）
  if (event.to.dataset.kind === 'archived') {
    formData.append('archive', 'true')
  } else if (event.to.dataset.progressId !== undefined) {
    formData.append('progress_id', event.to.dataset.progressId || '')
  }

  // プロジェクトの設定
  if (event.to.dataset.grouped === '1') {
    formData.append('project_id', event.to.dataset.projectId || '')
  }

  // ソート順のための前後要素の取得（共通）
  const siblings = Array.from(event.to.children).filter(el => el.matches('[data-task-id]'))
  const newIndex = event.newIndex
  const prevEl = siblings[newIndex - 1] || null
  const nextEl = siblings[newIndex + 1] || null

  formData.append('prev_task_id', prevEl?.dataset.taskId || '')
  formData.append('next_task_id', nextEl?.dataset.taskId || '')

  // カスタムパラメータの追加
  Object.entries(options).forEach(([key, value]) => {
    formData.append(key, value)
  })

  // フェッチでPUTリクエストを送信
  return fetch(form.action, {
    method: 'PUT',
    body: formData,
    headers: {
      'Accept': 'text/vnd.turbo-stream.html',
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']")?.content
    }
  })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
}